var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "luna-icon-grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8190873,10.7124255 C20.5021724,9.9803617 20.5021724,9.9803617 12.0105767,6.91270213 C7.73615116,5.36891489 6.94300222,3.8783617 10.0367044,3.20374468 C10.1874065,3.171 10.3392575,3.1422766 10.4926405,3.11719149 C10.9656192,3.04021277 11.4512363,3 11.9460448,3 C16.4730448,3 20.2151299,6.3552766 20.8190873,10.7124255",
    id: "Fill-7",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8175746,10.7088638 C20.5707448,10.1386085 20.5079363,10.0114596 16.4292129,8.51535319 C17.290915,10.6943106 18.8096171,11.8602894 20.791915,13.3740128 C20.8658299,12.9109915 20.9043192,12.4360979 20.9043192,11.9520128 C20.9043192,11.5301617 20.8742554,11.1152043 20.8175746,10.7088638",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8126107,14.1893362 C8.91561073,12.4475489 6.48350435,8.91265532 6.34161073,5.35497447 C6.33548307,5.20484681 6.15701499,5.13016596 6.04403627,5.22935745 C4.16035542,6.88516596 2.97790861,9.31842128 3.00031286,12.0276128 C3.04014265,16.8512298 6.95878095,20.8112298 11.7858448,20.9027617 C15.6834192,20.9762936 19.0268235,18.5629532 20.3329724,15.1437191 C20.3846746,15.0087191 20.2646107,14.8691234 20.124249,14.9043574 C17.8537597,15.4753787 15.2617597,15.2840809 12.8126107,14.1893362",
    id: "Fill-1",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuna);
export default __webpack_public_path__ + "static/media/luna.91a91e48.svg";
export { ForwardRef as ReactComponent };